import React, { Component } from 'react';
import propTypes from 'prop-types';
import { MainContent, PageHeader, Content } from 'client/components/App';
import ConnectedSWTDTester from 'client/components/SWTD/ConnectedSWTDTester';
import { Helmet } from 'react-helmet';
import ConnectedSWTDOptionsForm from 'client/components/SWTD/ConnectedSWTDOptionsForm';
import InstanceSetup from 'client/components/Instance/InstanceSetup';
import InstanceParentAlert from 'client/components/Instance/components/InstanceParentAlert';

export default class SWTDSetup extends Component {

  static propTypes = {
    instanceId: propTypes.string.isRequired,
  };

  render () {
    const { instanceId } = this.props;
    return (
      <Content>
        <Helmet>
          <title>Snow Atlas → TOPdesk</title>
        </Helmet>
        <PageHeader>Setup Wizard</PageHeader>
        <MainContent>
          <InstanceParentAlert />
          <InstanceSetup
            id={instanceId}
            OptionsFormComponent={ConnectedSWTDOptionsForm}
            TesterComponent={ConnectedSWTDTester}
            endpointOrder={['snow', 'topdesk']}
          />
        </MainContent>
      </Content>
    );
  }

}
